import { useTranslations } from "@jugl-web/utils";
import React from "react";
import { useLocalStorage } from "@jugl-web/utils/hooks/useStorage";
import { PERSONALISED_MENU_POPUP_SHOWN } from "@jugl-web/utils/storage";
import { InfoAlertDialog } from "@jugl-web/ui-kit";
import mainImage from "./assets/main.png";
import { SIDEBAR_MAX_VISIBLE_ITEMS } from "../../consts";
import { useHomeSidebar } from "../../hooks/useHomeSidebar";

export const PersonalisedMenuPopup: React.FC<{
  onPersonaliseMenuDialogOpen: () => void;
}> = ({ onPersonaliseMenuDialogOpen }) => {
  const [isPopupOpen, setIsPopupOpen] = useLocalStorage<boolean>(
    PERSONALISED_MENU_POPUP_SHOWN,
    true
  );

  const { t } = useTranslations();
  const { allItems } = useHomeSidebar();

  return (
    <InfoAlertDialog
      isOpen={isPopupOpen}
      onClose={() => setIsPopupOpen(false)}
      img={mainImage}
      title={t({
        id: "personalised-menu-popup-component.personalised-menu-is-here",
        defaultMessage: "Personalised Menu is here!",
      })}
      content={
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-2.5">
            <span>📌</span>
            <span>
              {allItems.length > SIDEBAR_MAX_VISIBLE_ITEMS
                ? t(
                    {
                      id: "personalised-menu-popup-component.pin-items-to-side-menu-count",
                      defaultMessage:
                        "Pin up to {count} favourite Items to the side menu!",
                    },
                    { count: SIDEBAR_MAX_VISIBLE_ITEMS }
                  )
                : t({
                    id: "personalised-menu-popup-component.pin-items-to-side-menu",
                    defaultMessage: "Pin favourite Items to the side menu!",
                  })}
            </span>
          </div>
          <div className="flex items-center gap-2.5">
            <span>️️⚙️</span>
            <span>
              {t({
                id: "personalised-menu-popup-component.hide-all-additional-items",
                defaultMessage: `Hide all additional Items under “More”`,
              })}
            </span>
          </div>
        </div>
      }
      buttons={[
        {
          text: t({
            id: "personalised-menu-popup-component.personalise-menu",
            defaultMessage: "Personalise Menu",
          }),
          onClick: () => {
            onPersonaliseMenuDialogOpen();
            setIsPopupOpen(false);
          },
        },
      ]}
    />
  );
};
